import { Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import type { DataTable } from "@/types";
import { htmlify } from "@/services/utils";
import { HypotheticalValue } from "../HypertheticalValue/HypotheticalValue";

interface Props {
	data: DataTable;
	unitType: string | undefined;
	unitValue: number | undefined;
	unitCurrency: string | undefined;
}

export const PerfomanceTable = ({ data, unitType, unitValue, unitCurrency }: Props) => {
	return (
		<TableContainer data-testid="PerfomanceTable">
			<Table variant="performances" overflow="auto">
				{data.header && (
					<Thead>
						<Tr>
							{data.header.map((value, index) => {
								return (
									<Th
										scope="col"
										key={index}
										paddingX={1}
										paddingY={2}
										wordBreak="break-word"
										_first={{
											width: { md: "15%", xl: FIRST_COLUMN_WIDTH },
											paddingLeft: 2,
											textTransform: "math-auto",
											textAlign: "start",
											...mobileAfter,
											...mobileProps
										}}
										sx={{
											width: {
												md: `calc((100% - 15%) / ${data.header.length - 1})`,
												xl: `calc((100% - ${FIRST_COLUMN_WIDTH}) / ${data.header.length - 1})`
											}
										}}
									>
										<Text
											variant="digitRegular"
											fontSize="md"
											lineHeight={3}
											overflowWrap="anywhere"
											whiteSpace="break-spaces"
										>
											{htmlify(value)}
										</Text>
									</Th>
								);
							})}
						</Tr>
					</Thead>
				)}
				<Tbody>
					{data.rows.map((row, index) => {
						return (
							<Tr key={index} data-testid={data.rowTypes[index]}>
								{row.map((value, index) => {
									return (
										<Td
											key={index}
											paddingX={1}
											paddingY={4}
											_first={{
												paddingLeft: 2,
												background: "inherit",
												...mobileAfter,
												...mobileProps,
												"& > div": {
													justifyContent: "start",
													width: { base: "120px", md: "unset" }
												}
											}}
											_notFirst={{
												"& > div": {
													width: { base: "120px", md: "unset" }
												}
											}}
										>
											<HypotheticalValue
												value={value as string}
												includeInvestmentAmount={false}
												format={data.cellFormatter}
												unitType={unitType}
												unitValue={unitValue}
												unitCurrency={unitCurrency}
											/>
										</Td>
									);
								})}
							</Tr>
						);
					})}
				</Tbody>
			</Table>
		</TableContainer>
	);
};
const FIRST_COLUMN_WIDTH = "30%";

const mobileProps = {
	position: { base: "sticky", md: "unset" },
	left: { base: "0", md: "unset" },
	zIndex: { base: "docked", md: "unset" },
	whiteSpace: { base: "break-spaces", md: "normal" }
};

const mobileAfter = {
	_after: {
		boxShadow: "inset 10px 0 8px -8px rgb(0 0 0 / 25%)",
		content: { base: `''`, md: "unset" },
		position: "absolute",
		top: 0,
		right: 0,
		bottom: "-1px",
		width: "30px",
		transform: "translateX(100%)"
	}
};
